/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

export interface RolePositionPayloadItem {
	id: string;
	position: number;
}

export interface RoleHoistPositionPayloadItem {
	id: string;
	hoist_position: number;
}

export interface SubmittableRoleOrderParams {
	guildId: string;
	orderedRoleIds: ReadonlyArray<string>;
	isRoleLocked: (roleId: string) => boolean;
}

interface OrderedRoleIdsParams {
	guildId: string;
	orderedRoleIds: ReadonlyArray<string>;
}

function getNormalisedRoleOrderIds(params: OrderedRoleIdsParams): Array<string> {
	const {guildId, orderedRoleIds} = params;
	const seen = new Set<string>();
	const normalisedIds: Array<string> = [];

	for (const roleId of orderedRoleIds) {
		if (roleId === guildId) {
			continue;
		}
		if (seen.has(roleId)) {
			continue;
		}
		seen.add(roleId);
		normalisedIds.push(roleId);
	}

	return normalisedIds;
}

export function createSubmittableRoleOrderIds(params: SubmittableRoleOrderParams): Array<string> {
	const normalisedIds = getNormalisedRoleOrderIds(params);
	return normalisedIds.filter((roleId) => !params.isRoleLocked(roleId));
}

export function createRoleOrderPayload(params: OrderedRoleIdsParams): Array<RolePositionPayloadItem> {
	const orderedIds = getNormalisedRoleOrderIds(params);
	return orderedIds.map((id, index) => ({
		id,
		position: orderedIds.length - index,
	}));
}

export function createRoleHoistOrderPayload(params: OrderedRoleIdsParams): Array<RoleHoistPositionPayloadItem> {
	const orderedIds = getNormalisedRoleOrderIds(params);
	return orderedIds.map((id, index) => ({
		id,
		hoist_position: orderedIds.length - index,
	}));
}
